import { useNavigate } from 'react-router-dom';

import { toast } from 'material-react-toastify';

import { useHubStore } from '@/lib/store/hubStore';
import { defineSignInRoute } from '@/lib/utils/sign-in';
import { authService } from '@/services/auth';
import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';

export const useSignIn = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async ({ email, password }: { email: string; password: string }) => {
      const response = await authService.signIn(email, password);
      if (response.error) {
        throw new Error(response.errorMessage as string);
      }
      return { email, role: response.role };
    },
    onSuccess: ({ email, role }) => {
      const roleType = role ?? null;
      useHubStore.setState({ user: { email, role: roleType } });

      const { route } = defineSignInRoute(roleType);
      navigate(route);
    },
    onError: (error: Error) => {
      Sentry.captureException(`Failed to sign in: ${error.message}`);
      toast.error(error.message);
    },
  });
};
